var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localText)?_c('span',[_vm._v(_vm._s(_vm.localText))]):_c('span',{staticClass:"font-italic font-small-3"},[_vm._v(_vm._s(_vm.$t('common.not_specified')))])}
var staticRenderFns = []

export { render, staticRenderFns }